export default __webpack_public_path__ + "static/media/3.eebdb96e.svg";